// @ts-nocheck

import React from 'react';
import styled, { css } from 'styled-components';

import { Target } from '../../../../client';
import { __ } from '../../../../i18n/l10n';
import type { CopySystemGridType, RemoveSystemGridType } from '../../types/actions';

const Wrap = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  margin: 1em 1em 2em;
`;

const Button = styled.div`
  min-height: 3em;
  cursor: pointer;
  &:active .gridSystemButton {
    transform: scale(0.9);
  }
  ${({ theme }) =>
    Target.__MOBILE__
      ? undefined
      : css`
          &:hover .gridSystemButton {
            background: ${theme.grids.colors.darkgrey3};
          }
        `}
`;

const P = styled.p`
  text-align: center;
  color: ${({ theme }) => theme.grids.colors.middlegrey3};
  font-family: BettingPoliticaBold, sans-serif;
  margin-top: 1em;
`;

const Icon = styled.svg`
  display: block;
  width: 3em;
  height: 3em;
  margin: 0 auto;
  border-radius: 50%;
  border: solid 1px ${({ $isRed, theme }) => ($isRed ? theme.grids.colors.redlight : '#fff')};
  padding: 0.8em;
  line {
    stroke-width: 0.5;
    stroke: ${({ $isRed, theme }) => ($isRed ? theme.grids.colors.redlight : '#fff')};
  }
  transition: background 300ms ease-out;
  background: transparent;
`;

type GridsSystemActionsProps = {
  className?: string;
  isSystem: boolean;
  copySystemGrid: CopySystemGridType;
  removeSystemGrid: RemoveSystemGridType;
  onlyDuplicate?: boolean;
};

const GridsSystemActions = ({
  className,
  isSystem,
  copySystemGrid,
  removeSystemGrid,
  onlyDuplicate = false,
}: GridsSystemActionsProps) => {
  return isSystem ? (
    <Wrap className={className}>
      {!onlyDuplicate && (
        <Button onClick={removeSystemGrid} data-testid="grid-system-remove-button">
          <Icon className="gridSystemButton" viewBox="0 0 10 10" $isRed>
            <line x1="0" y1="5" x2="10" y2="5" />
          </Icon>
          <P>{__('Delete grid')}</P>
        </Button>
      )}
      <Button onClick={copySystemGrid} data-testid="grid-system-duplicate-button">
        <Icon className="gridSystemButton" viewBox="0 0 10 10">
          <line x1="0" y1="5" x2="10" y2="5" />
          <line x1="5" y1="0" x2="5" y2="10" />
        </Icon>
        <P>{__('Duplicate grid')}</P>
      </Button>
    </Wrap>
  ) : null;
};

export default GridsSystemActions;
